export default __webpack_public_path__ + "static/media/facebook.8252f9b7.svg";